//src/actions/types.js
// Auth Types
export const EMAIL_CHANGED = 'EMAIL_CHANGED';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const LOGGED_IN_SUCCESS = 'LOGGED_IN_SUCCESS';
export const LOGGED_IN_FAIL = 'LOGGED_IN_FAIL';
export const SET_TOKEN = 'SET_TOKEN';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const CLEAR_CHANGE_PASSWORD_ERROR = 'CLEAR_CHANGE_PASSWORD_ERROR';

// Dashboard Types
// Types for Q1 statistics
export const FETCH_DASHBOARD_STATS_SUCCESS_Q1 = "FETCH_DASHBOARD_STATS_SUCCESS_Q1";
export const FETCH_DASHBOARD_STATS_FAIL_Q1 = "FETCH_DASHBOARD_STATS_FAIL_Q1";
export const FETCH_DASHBOARD_STATS_LOADING_Q1 = "FETCH_DASHBOARD_STATS_LOADING_Q1";

// Types for Q2 statistics
export const FETCH_DASHBOARD_STATS_SUCCESS_Q2 = "FETCH_DASHBOARD_STATS_SUCCESS_Q2";
export const FETCH_DASHBOARD_STATS_FAIL_Q2 = "FETCH_DASHBOARD_STATS_FAIL_Q2";
export const FETCH_DASHBOARD_STATS_LOADING_Q2 = "FETCH_DASHBOARD_STATS_LOADING_Q2";

// Types for Q3 statistics
export const FETCH_DASHBOARD_STATS_SUCCESS_Q3 = "FETCH_DASHBOARD_STATS_SUCCESS_Q3";
export const FETCH_DASHBOARD_STATS_FAIL_Q3 = "FETCH_DASHBOARD_STATS_FAIL_Q3";
export const FETCH_DASHBOARD_STATS_LOADING_Q3 = "FETCH_DASHBOARD_STATS_LOADING_Q3";

// ALL RECIPES STATS
export const FETCH_RECIPES_STATS_SUCCESS = "FETCH_RECIPES_STATS_SUCCESS";
export const FETCH_RECIPES_STATS_FAIL = "FETCH_RECIPES_STATS_FAIL";
export const FETCH_RECIPES_STATS_LOADING = "FETCH_RECIPES_STATS_LOADING";

//CUSTOM RECIPE STATS
export const FETCH_CUSTOM_RECIPES_STATS_SUCCESS = "FETCH_CUSTOM_RECIPES_STATS_SUCCESS";
export const FETCH_CUSTOM_RECIPES_STATS_FAIL = "FETCH_CUSTOM_RECIPES_STATS_FAIL";
export const FETCH_CUSTOM_RECIPES_STATS_LOADING = "FETCH_CUSTOM_RECIPES_STATS_LOADING";

//GET RECIPES WITH PARAMS
export const FETCH_RECIPES_STATS_WITH_PARAMS_SUCCESS = "FETCH_RECIPES_STATS_WITH_PARAMS_SUCCESS";
export const FETCH_RECIPES_STATS_WITH_PARAMS_FAIL = "FETCH_RECIPES_STATS_WITH_PARAMS_FAIL";
export const FETCH_RECIPES_STATS_WITH_PARAMS_LOADING = "FETCH_RECIPES_STATS_WITH_PARAMS_LOADING";

// RECIPES DEVICES STATS 
export const FETCH_DEVICE_RECIPES_STATS_SUCCESS = "FETCH_DEVICE_RECIPES_STATS_SUCCESS";
export const FETCH_DEVICE_RECIPES_STATS_FAIL = "FETCH_DEVICE_RECIPES_STATS_FAIL";
export const FETCH_DEVICE_RECIPES_STATS_LOADING = "FETCH_DEVICE_RECIPES_STATS_LOADING";

// Latest Recipes
export const FETCH_LATEST_RECIPES_LOADING = 'FETCH_LATEST_RECIPES_LOADING';
export const FETCH_LATEST_RECIPES_SUCCESS = 'FETCH_LATEST_RECIPES_SUCCESS';
export const FETCH_LATEST_RECIPES_FAIL    = 'FETCH_LATEST_RECIPES_FAIL';


// CURATE RECIPES SEARCH
export const FETCH_CURATED_RECIPES_TILE_SEARCH_SUCCESS = "FETCH_CURATED_RECIPES_TILE_SEARCH_SUCCESS";
export const FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL = "FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL";
export const FETCH_CURATED_RECIPES_TILE_SEARCH_LOADING = "FETCH_CURATED_RECIPES_TILE_SEARCH_LOADING";

// INGREDIENTS SEARCH
export const FETCH_INGREDIENTS_TILE_SEARCH_SUCCESS = "FETCH_INGREDIENTS_TILE_SEARCH_SUCCESS";
export const FETCH_INGREDIENTS_TILE_SEARCH_FAIL = "FETCH_INGREDIENTS_TILE_SEARCH_FAIL";
export const FETCH_INGREDIENTS_TILE_SEARCH_LOADING = "FETCH_INGREDIENTS_TILE_SEARCH_LOADING";

//BRANDS SEARCH
export const FETCH_BRANDS_TILE_SEARCH_LOADING = 'FETCH_BRANDS_TILE_SEARCH_LOADING';
export const FETCH_BRANDS_TILE_SEARCH_SUCCESS = 'FETCH_BRANDS_TILE_SEARCH_SUCCESS';
export const FETCH_BRANDS_TILE_SEARCH_FAIL = 'FETCH_BRANDS_TILE_SEARCH_FAIL';

//INFLUENCERS SEARCH
export const FETCH_INFLUENCERS_TILE_SEARCH_LOADING = 'FETCH_INFLUENCERS_TILE_SEARCH_LOADING';
export const FETCH_INFLUENCERS_TILE_SEARCH_SUCCESS = 'FETCH_INFLUENCERS_TILE_SEARCH_SUCCESS';
export const FETCH_INFLUENCERS_TILE_SEARCH_FAIL = 'FETCH_INFLUENCERS_TILE_SEARCH_FAIL';

//INFLUENCERS RECIPIES
export const FETCH_INFLUENCER_RECIPES_LOADING = 'FETCH_INFLUENCER_RECIPES_LOADING';
export const FETCH_INFLUENCER_RECIPES_SUCCESS = 'FETCH_INFLUENCER_RECIPES_SUCCESS';
export const FETCH_INFLUENCER_RECIPES_FAIL = 'FETCH_INFLUENCER_RECIPES_FAIL';

//CURATED RECIPES V3 STATS
export const FETCH_CURATED_RECIPES_V3_LOADING = "FETCH_CURATED_RECIPES_V3_LOADING";
export const FETCH_CURATED_RECIPES_V3_SUCCESS = "FETCH_CURATED_RECIPES_V3_SUCCESS";
export const FETCH_CURATED_RECIPES_V3_FAIL = "FETCH_CURATED_RECIPES_V3_FAIL";

//INGREDIENTS V3 STATS
export const FETCH_INGREDIENTS_V3_LOADING = "FETCH_INGREDIENTS_V3_LOADING";
export const FETCH_INGREDIENTS_V3_SUCCESS = "FETCH_INGREDIENTS_V3_SUCCESS";
export const FETCH_INGREDIENTS_V3_FAIL = "FETCH_INGREDIENTS_V3_FAIL";

//STATS DATA STATIC JSON
export const FETCH_STATS_DATA_JSON_LOADING = "FETCH_STATS_DATA_JSON_LOADING";
export const FETCH_STATS_DATA_JSON_SUCCESS = "FETCH_STATS_DATA_JSON_SUCCESS";
export const FETCH_STATS_DATA_JSON_FAIL = "FETCH_STATS_DATA_JSON_FAIL";

//STATS COUNTRY DATA STATIC JSON
export const FETCH_COUNTRY_DATA_JSON_LOADING = "FETCH_COUNTRY_DATA_JSON_LOADING";
export const FETCH_COUNTRY_DATA_JSON_SUCCESS = "FETCH_COUNTRY_DATA_JSON_SUCCESS";
export const FETCH_COUNTRY_DATA_JSON_FAIL = "FETCH_COUNTRY_DATA_JSON_FAIL";

//STATS SOURCE DATA STATIC JSON
export const FETCH_SOURCE_DATA_JSON_LOADING = "FETCH_SOURCE_DATA_JSON_LOADING";
export const FETCH_SOURCE_DATA_JSON_SUCCESS = "FETCH_SOURCE_DATA_JSON_SUCCESS";
export const FETCH_SOURCE_DATA_JSON_FAIL = "FETCH_SOURCE_DATA_JSON_FAIL";


//STATS PRODUCTS DATA STATIC JSON
export const FETCH_PRODUCT_DATA_JSON_LOADING = "FETCH_PRODUCT_DATA_JSON_LOADING";
export const FETCH_PRODUCT_DATA_JSON_SUCCESS = "FETCH_PRODUCT_DATA_JSON_SUCCESS";
export const FETCH_PRODUCT_DATA_JSON_FAIL = "FETCH_PRODUCT_DATA_JSON_FAIL";

//HARDWARE TITLE INFO V1
export const FETCH_HARDWARE_CHART_TILE_INFO_LOADING = "FETCH_HARDWARE_CHART_TILE_INFO_LOADING";
export const FETCH_HARDWARE_CHART_TILE_INFO_SUCCESS = "FETCH_HARDWARE_CHART_TILE_INFO_SUCCESS";
export const FETCH_HARDWARE_CHART_TILE_INFO_FAIL = "FETCH_HARDWARE_CHART_TILE_INFO_FAIL";

// BRANDS V3 --> Top Charts
export const FETCH_BRANDS_V3_LOADING = 'FETCH_BRANDS_V3_LOADING';
export const FETCH_BRANDS_V3_SUCCESS = 'FETCH_BRANDS_V3_SUCCESS';
export const FETCH_BRANDS_V3_FAIL = 'FETCH_BRANDS_V3_FAIL';

// INFLUENCER V3 --> Top Charts
export const FETCH_INFLUENCER_V3_LOADING = 'FETCH_INFLUENCER_V3_LOADING';
export const FETCH_INFLUENCER_V3_SUCCESS = 'FETCH_INFLUENCER_V3_SUCCESS';
export const FETCH_INFLUENCER_V3_FAIL = 'FETCH_INFLUENCER_V3_FAIL';

// Dashboard Types for Compare Active VS New Users endpoints
export const FETCH_COMPARE_USERS_WEEK_LOADING = "FETCH_COMPARE_USERS_WEEK_LOADING";
export const FETCH_COMPARE_USERS_WEEK_SUCCESS = "FETCH_COMPARE_USERS_WEEK_SUCCESS";
export const FETCH_COMPARE_USERS_WEEK_FAIL = "FETCH_COMPARE_USERS_WEEK_FAIL";

export const FETCH_COMPARE_USERS_MONTH_LOADING = "FETCH_COMPARE_USERS_MONTH_LOADING";
export const FETCH_COMPARE_USERS_MONTH_SUCCESS = "FETCH_COMPARE_USERS_MONTH_SUCCESS";
export const FETCH_COMPARE_USERS_MONTH_FAIL = "FETCH_COMPARE_USERS_MONTH_FAIL";

export const FETCH_COMPARE_USERS_YEAR_LOADING = "FETCH_COMPARE_USERS_YEAR_LOADING";
export const FETCH_COMPARE_USERS_YEAR_SUCCESS = "FETCH_COMPARE_USERS_YEAR_SUCCESS";
export const FETCH_COMPARE_USERS_YEAR_FAIL = "FETCH_COMPARE_USERS_YEAR_FAIL";

export const FETCH_COMPARE_USERS_DAY_LOADING = "FETCH_COMPARE_USERS_DAY_LOADING";
export const FETCH_COMPARE_USERS_DAY_SUCCESS = "FETCH_COMPARE_USERS_DAY_SUCCESS";
export const FETCH_COMPARE_USERS_DAY_FAIL = "FETCH_COMPARE_USERS_DAY_FAIL";

// New Recipes - Dashboard Endpoints
export const FETCH_USER_RECIPES_LOADING = "FETCH_USER_RECIPES_LOADING";
export const FETCH_USER_RECIPES_SUCCESS = "FETCH_USER_RECIPES_SUCCESS";
export const FETCH_USER_RECIPES_FAIL = "FETCH_USER_RECIPES_FAIL";

export const FETCH_CURATED_RECIPES_LOADING = "FETCH_CURATED_RECIPES_LOADING";
export const FETCH_CURATED_RECIPES_SUCCESS = "FETCH_CURATED_RECIPES_SUCCESS";
export const FETCH_CURATED_RECIPES_FAIL = "FETCH_CURATED_RECIPES_FAIL";

export const FETCH_BRAND_RECIPES_LOADING = "FETCH_BRAND_RECIPES_LOADING";
export const FETCH_BRAND_RECIPES_SUCCESS = "FETCH_BRAND_RECIPES_SUCCESS";
export const FETCH_BRAND_RECIPES_FAIL = "FETCH_BRAND_RECIPES_FAIL";

//MixList Dashboard - List
export const FETCH_PLAYLIST_MIXILISTS_LOADING = "FETCH_PLAYLIST_MIXLISTS_LOADING";
export const FETCH_PLAYLIST_MIXLISTS_SUCCESS = "FETCH_PLAYLIST_MIXLISTS_SUCCESS";
export const FETCH_PLAYLIST_MIXLISTS_FAIL = "FETCH_PLAYLIST_MIXLISTS_FAIL";

export const FETCH_PLAYLIST_BRANDS_LOADING = "FETCH_PLAYLIST_BRANDS_LOADING";
export const FETCH_PLAYLIST_BRANDS_SUCCESS = "FETCH_PLAYLIST_BRANDS_SUCCESS";
export const FETCH_PLAYLIST_BRANDS_FAIL = "FETCH_PLAYLIST_BRANDS_FAIL";

export const FETCH_PLAYLIST_INFLUENCERS_LOADING = "FETCH_PLAYLIST_BRANDS_LOADING";
export const FETCH_PLAYLIST_INFLUENCERS_SUCCESS = "FETCH_PLAYLIST_BRANDS_SUCCESS";
export const FETCH_PLAYLIST_INFLUENCERS_FAIL = "FETCH_PLAYLIST_BRANDS_FAIL";

// Dashboard User Tile Info for Total Registered Users Expansion
export const FETCH_USER_TILE_INFO_LOADING = "FETCH_USER_TILE_INFO_LOADING";
export const FETCH_USER_TILE_INFO_SUCCESS = "FETCH_USER_TILE_INFO_SUCCESS";
export const FETCH_USER_TILE_INFO_FAIL = "FETCH_USER_TILE_INFO_FAIL";

//Dashboard
// Crafted Cocktails Expansion
export const FETCH_CRAFTED_COCKTAILS_EXPAND_LOADING = "FETCH_CRAFTED_COCKTAILS_EXPAND_LOADING";
export const FETCH_CRAFTED_COCKTAILS_EXPAND_SUCCESS = "FETCH_CRAFTED_COCKTAILS_EXPAND_SUCCESS";
export const FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL = "FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL";

//Dashboard
// Hardware Usage Stats
export const FETCH_HARDWARE_USAGE_STATS_LOADING  = 'FETCH_HARDWARE_USAGE_STATS_LOADING';
export const FETCH_HARDWARE_USAGE_STATS_SUCCESS  = 'FETCH_HARDWARE_USAGE_STATS_SUCCESS';
export const FETCH_HARDWARE_USAGE_STATS_FAIL     = 'FETCH_HARDWARE_USAGE_STATS_FAIL';

//Hardware Page TYPES
export const FETCH_HARDWARE_SOLD_LOADING = "FETCH_HARDWARE_SOLD_LOADING";
export const FETCH_HARDWARE_SOLD_SUCCESS = "FETCH_HARDWARE_SOLD_SUCCESS";
export const FETCH_HARDWARE_SOLD_FAIL = "FETCH_HARDWARE_SOLD_FAIL";

export const FETCH_HARDWARE_CRAFTED_LOADING = "FETCH_HARDWARE_CRAFTED_LOADING";
export const FETCH_HARDWARE_CRAFTED_SUCCESS = "FETCH_HARDWARE_CRAFTED_SUCCESS";
export const FETCH_HARDWARE_CRAFTED_FAIL = "FETCH_HARDWARE_CRAFTED_FAIL";

export const FETCH_HARDWARE_ACTIVE_LOADING = "FETCH_HARDWARE_ACTIVE_LOADING";
export const FETCH_HARDWARE_ACTIVE_SUCCESS = "FETCH_HARDWARE_ACTIVE_SUCCESS";
export const FETCH_HARDWARE_ACTIVE_FAIL = "FETCH_HARDWARE_ACTIVE_FAIL";

export const FETCH_HARDWARE_ACTIVATED_LOADING = "FETCH_HARDWARE_ACTIVATED_LOADING";
export const FETCH_HARDWARE_ACTIVATED_SUCCESS = "FETCH_HARDWARE_ACTIVATED_SUCCESS";
export const FETCH_HARDWARE_ACTIVATED_FAIL = "FETCH_HARDWARE_ACTIVATED_FAIL";

// compare users (any period) - Expanded
export const FETCH_COMPARE_USERS_LOADING  = "FETCH_COMPARE_USERS_LOADING";
export const FETCH_COMPARE_USERS_SUCCESS  = "FETCH_COMPARE_USERS_SUCCESS";
export const FETCH_COMPARE_USERS_FAIL     = "FETCH_COMPARE_USERS_FAIL";


// HARDWARE PROFILE 
// DRINKS
export const FETCH_HARDWARE_DRINKS_LOADING = "FETCH_HARDWARE_DRINKS_LOADING";
export const FETCH_HARDWARE_DRINKS_SUCCESS = "FETCH_HARDWARE_DRINKS_SUCCESS";
export const FETCH_HARDWARE_DRINKS_FAIL = "FETCH_HARDWARE_DRINKS_FAIL";
//STATION DETAILS
export const FETCH_HARDWARE_DETAILS_LOADING = "FETCH_HARDWARE_DETAILS_LOADING";
export const FETCH_HARDWARE_DETAILS_SUCCESS = "FETCH_HARDWARE_DETAILS_SUCCESS";
export const FETCH_HARDWARE_DETAILS_FAIL = "FETCH_HARDWARE_DETAILS_FAIL";
//INGREDIENTS HISTORY
export const FETCH_HARDWARE_ING_HISTORY_LOADING = "FETCH_HARDWARE_ING_HISTORY_LOADING";
export const FETCH_HARDWARE_ING_HISTORY_SUCCESS = "FETCH_HARDWARE_ING_HISTORY_SUCCESS";
export const FETCH_HARDWARE_ING_HISTORY_FAIL = "FETCH_HARDWARE_ING_HISTORY_FAIL";

//DEVICE USERS
export const FETCH_HARDWARE_USERS_LOADING = "FETCH_HARDWARE_USERS_LOADING";
export const FETCH_HARDWARE_USERS_SUCCESS = "FETCH_HARDWARE_USERS_SUCCESS";
export const FETCH_HARDWARE_USERS_FAIL = "FETCH_HARDWARE_USERS_FAIL";

//RECENT DRINKS
export const FETCH_HARDWARE_RECENT_DRINKS_LOADING = "FETCH_HARDWARE_RECENT_DRINKS_LOADING";
export const FETCH_HARDWARE_RECENT_DRINKS_SUCCESS = "FETCH_HARDWARE_RECENT_DRINKS_SUCCESS";
export const FETCH_HARDWARE_RECENT_DRINKS_FAIL = "FETCH_HARDWARE_RECENT_DRINKS_FAIL";

//MOST REPEATED DRINKS
export const FETCH_HARDWARE_MOST_REPEATED_DRINKS_LOADING = "FETCH_HARDWARE_MOST_REPEATED_DRINKS_LOADING";
export const FETCH_HARDWARE_MOST_REPEATED_DRINKS_SUCCESS = "FETCH_HARDWARE_MOST_REPEATED_DRINKS_SUCCESS";
export const FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL = "FETCH_HARDWARE_MOST_REPEATED_DRINKS_FAIL";

//DEVICE Cleaning History per Station
export const FETCH_HARDWARE_CLEANING_HISTORY_LOADING  = 'FETCH_HARDWARE_CLEANING_HISTORY_LOADING';
export const FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS  = 'FETCH_HARDWARE_CLEANING_HISTORY_SUCCESS';
export const FETCH_HARDWARE_CLEANING_HISTORY_FAIL     = 'FETCH_HARDWARE_CLEANING_HISTORY_FAIL';

//Last Activity Devices
export const FETCH_PAGINATED_DEVICES_LOADING = "FETCH_PAGINATED_DEVICES_LOADING";
export const FETCH_PAGINATED_DEVICES_SUCCESS = "FETCH_PAGINATED_DEVICES_SUCCESS";
export const FETCH_PAGINATED_DEVICES_FAIL = "FETCH_PAGINATED_DEVICES_FAIL";
export const SET_PAGINATED_DEVICES_PAGE = "SET_PAGINATED_DEVICES_PAGE";

//Users Page
export const FETCH_PAGE_USER_INFO_LOADING = "FETCH_PAGE_USER_INFO_LOADING";
export const FETCH_PAGE_USER_INFO_SUCCESS = "FETCH_PAGE_USER_INFO_SUCCESS";
export const FETCH_PAGE_USER_INFO_FAIL = "FETCH_PAGE_USER_INFO_FAIL";

export const FETCH_PAGE_USER_SUMMARY_LOADING = 'FETCH_PAGE_USER_SUMMARY_LOADING';
export const FETCH_PAGE_USER_SUMMARY_SUCCESS = 'FETCH_PAGE_USER_SUMMARY_SUCCESS';
export const FETCH_PAGE_USER_SUMMARY_FAIL = 'FETCH_PAGE_USER_SUMMARY_FAIL';

export const FETCH_PAGE_USERS_PAGINATED_LOADING = 'FETCH_PAGE_USERS_PAGINATED_LOADING';
export const FETCH_PAGE_USERS_PAGINATED_SUCCESS = 'FETCH_PAGE_USERS_PAGINATED_SUCCESS';
export const FETCH_PAGE_USERS_PAGINATED_FAIL = 'FETCH_PAGE_USERS_PAGINATED_FAIL';

//User Profile
export const FETCH_PAGE_USER_PHONENAME_LOADING = "FETCH_PAGE_USER_PHONENAME_LOADING";
export const FETCH_PAGE_USER_PHONENAME_SUCCESS = "FETCH_PAGE_USER_PHONENAME_SUCCESS";
export const FETCH_PAGE_USER_PHONENAME_FAIL = "FETCH_PAGE_USER_PHONENAME_FAIL";

//My Drinks
export const FETCH_PAGE_USER_DRINKS_LOADING = "FETCH_PAGE_USER_DRINKS_LOADING";
export const FETCH_PAGE_USER_DRINKS_SUCCESS = "FETCH_PAGE_USER_DRINKS_SUCCESS";
export const FETCH_PAGE_USER_DRINKS_FAIL = "FETCH_PAGE_USER_DRINKS_FAIL";

//My Crafted Drinks
export const FETCH_PAGE_USER_CRAFTEDDRINKS_LOADING = "FETCH_PAGE_USER_CRAFTEDDRINKS_LOADING";
export const FETCH_PAGE_USER_CRAFTEDDRINKS_SUCCESS = "FETCH_PAGE_USER_CRAFTEDDRINKS_SUCCESS";
export const FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL = "FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL";

//My BAR
export const FETCH_PAGE_USER_MYBAR_LOADING = "FETCH_PAGE_USER_MYBAR_LOADING";
export const FETCH_PAGE_USER_MYBAR_SUCCESS = "FETCH_PAGE_USER_MYBAR_SUCCESS";
export const FETCH_PAGE_USER_MYBAR_FAIL = "FETCH_PAGE_USER_MYBAR_FAIL";

//Users Recently Made Drinks
export const FETCH_RECENTLY_MADE_DRINKS_LOADING = 'FETCH_RECENTLY_MADE_DRINKS_LOADING';
export const FETCH_RECENTLY_MADE_DRINKS_SUCCESS = 'FETCH_RECENTLY_MADE_DRINKS_SUCCESS';
export const FETCH_RECENTLY_MADE_DRINKS_FAIL = 'FETCH_RECENTLY_MADE_DRINKS_FAIL';

// Users Most Repeated Drinks
export const FETCH_RECENTLY_MOST_REPEATED_DRINKS_LOADING = 'FETCH_RECENTLY_MOST_REPEATED_DRINKS_LOADING';
export const FETCH_MOST_REPEATED_DRINKS_SUCCESS = 'FETCH_MOST_REPEATED_DRINKS_SUCCESS';
export const FETCH_MOST_REPEATED_DRINKS_FAIL = 'FETCH_MOST_REPEATED_DRINKS_FAIL';

//users Favourite Drinks
export const FETCH_FAVOURITE_DRINKS_LOADING = 'FETCH_FAVOURITE_DRINKS_LOADING';
export const FETCH_FAVOURITE_DRINKS_SUCCESS = 'FETCH_FAVOURITE_DRINKS_SUCCESS';
export const FETCH_FAVOURITE_DRINKS_FAIL = 'FETCH_FAVOURITE_DRINKS_FAIL';

//Pagination State USERS and filters
export const SET_USERS_PAGE_CURRENT = "SET_USERS_PAGE_CURRENT";
export const SET_USERS_ITEMS_PER_PAGE = "SET_USERS_ITEMS_PER_PAGE";
export const SET_USERS_SEARCH_TERM = "SET_USERS_SEARCH_TERM";
export const SET_USERS_USER_TYPE = "SET_USERS_USER_TYPE";
export const SET_USERS_DATE_OPTION = "SET_USERS_DATE_OPTION";
export const SET_USERS_AGE_OPTION = "SET_USERS_AGE_OPTION";
export const SET_USERS_CUSTOM_DATE_RANGE = "SET_USERS_CUSTOM_DATE_RANGE";
export const SET_USERS_START_DATE = "SET_USERS_START_DATE";
export const SET_USERS_END_DATE = "SET_USERS_END_DATE";

//Users Profile Devices
export const FETCH_USER_DEVICES_LOADING = "FETCH_USER_DEVICES_LOADING";
export const FETCH_USER_DEVICES_SUCCESS = "FETCH_USER_DEVICES_SUCCESS";
export const FETCH_USER_DEVICES_FAIL = "FETCH_USER_DEVICES_FAIL";

// Last Connected History Action Types
export const FETCH_HARDWARE_LAST_CONNECTED_HISTORY_LOADING = "FETCH_HARDWARE_LAST_CONNECTED_HISTORY_LOADING";
export const FETCH_HARDWARE_LAST_CONNECTED_HISTORY_SUCCESS = "FETCH_HARDWARE_LAST_CONNECTED_HISTORY_SUCCESS";
export const FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL = "FETCH_HARDWARE_LAST_CONNECTED_HISTORY_FAIL";


//Recipes Page
export const FETCH_TOP_RECIPE_EVENT_COUNTS_LOADING = 'FETCH_TOP_RECIPE_EVENT_COUNTS_LOADING';
export const FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS = 'FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS';
export const FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL = 'FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL';

export const FETCH_SEARCH_RECIPES_LOADING = 'FETCH_SEARCH_RECIPES_LOADING';
export const FETCH_SEARCH_RECIPES_SUCCESS = 'FETCH_SEARCH_RECIPES_SUCCESS';
export const FETCH_SEARCH_RECIPES_FAIL = 'FETCH_SEARCH_RECIPES_FAIL';

//Search All Recipes Page
export const FETCH_SEARCH_ALLRECIPES_LOADING = "FETCH_SEARCH_ALLRECIPES_LOADING";
export const FETCH_SEARCH_ALLRECIPES_SUCCESS = "FETCH_SEARCH_ALLRECIPES_SUCCESS";
export const FETCH_SEARCH_ALLRECIPES_FAIL = "FETCH_SEARCH_ALLRECIPES_FAIL";

//Orders Pages
// Orders - Paginated List
export const FETCH_ORDERS_LOADING = "FETCH_ORDERS_LOADING";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAIL = "FETCH_ORDERS_FAIL";

// Orders - Single Order Details
export const FETCH_ORDER_DETAILS_LOADING = "FETCH_ORDER_DETAILS_LOADING";
export const FETCH_ORDER_DETAILS_SUCCESS = "FETCH_ORDER_DETAILS_SUCCESS";
export const FETCH_ORDER_DETAILS_FAIL = "FETCH_ORDER_DETAILS_FAIL";

// Pagination & Filters UI State
export const SET_ORDERS_PAGE_CURRENT = "SET_ORDERS_PAGE_CURRENT";
export const SET_ORDERS_ITEMS_PER_PAGE = "SET_ORDERS_ITEMS_PER_PAGE";
export const SET_ORDERS_DATE_RANGE = "SET_ORDERS_DATE_RANGE";

// Orders comparison
export const FETCH_ORDERS_COMPARISON_LOADING  = "FETCH_ORDERS_COMPARISON_LOADING";
export const FETCH_ORDERS_COMPARISON_SUCCESS  = "FETCH_ORDERS_COMPARISON_SUCCESS";
export const FETCH_ORDERS_COMPARISON_FAIL     = "FETCH_ORDERS_COMPARISON_FAIL";

// Orders export (flat list by explicit date range)
export const FETCH_ORDERS_EXPORT_LOADING = "FETCH_ORDERS_EXPORT_LOADING";
export const FETCH_ORDERS_EXPORT_SUCCESS = "FETCH_ORDERS_EXPORT_SUCCESS";
export const FETCH_ORDERS_EXPORT_FAIL    = "FETCH_ORDERS_EXPORT_FAIL";


// Admin Only Fetch Users in Settings
export const FETCH_USERS_LOADING  = 'FETCH_USERS_LOADING';
export const FETCH_USERS_SUCCESS  = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL     = 'FETCH_USERS_FAIL';

// Update Active Flag for a user
export const UPDATE_USER_FLAG_LOADING   = 'UPDATE_USER_FLAG_LOADING';
export const UPDATE_USER_FLAG_SUCCESS   = 'UPDATE_USER_FLAG_SUCCESS';
export const UPDATE_USER_FLAG_FAIL      = 'UPDATE_USER_FLAG_FAIL';

// Dashboard Admin Stats

export const FETCH_ADMIN_USER_STATS_LOADING = 'FETCH_ADMIN_USER_STATS_LOADING';
export const FETCH_ADMIN_USER_STATS_SUCCESS = 'FETCH_ADMIN_USER_STATS_SUCCESS';
export const FETCH_ADMIN_USER_STATS_FAIL    = 'FETCH_ADMIN_USER_STATS_FAIL';

export const FETCH_ADMIN_RECIPES_STATS_LOADING = 'FETCH_ADMIN_RECIPES_STATS_LOADING';
export const FETCH_ADMIN_RECIPES_STATS_SUCCESS = 'FETCH_ADMIN_RECIPES_STATS_SUCCESS';
export const FETCH_ADMIN_RECIPES_STATS_FAIL    = 'FETCH_ADMIN_RECIPES_STATS_FAIL';

export const FETCH_ADMIN_CUSTOM_RECIPES_STATS_LOADING  = 'FETCH_ADMIN_CUSTOM_RECIPES_STATS_LOADING';
export const FETCH_ADMIN_CUSTOM_RECIPES_STATS_SUCCESS  = 'FETCH_ADMIN_CUSTOM_RECIPES_STATS_SUCCESS';
export const FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL     = 'FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL';

export const FETCH_ADMIN_MAKE_RECIPES_STATS_LOADING  = 'FETCH_ADMIN_MAKE_RECIPES_STATS_LOADING';
export const FETCH_ADMIN_MAKE_RECIPES_STATS_SUCCESS  = 'FETCH_ADMIN_MAKE_RECIPES_STATS_SUCCESS';
export const FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL     = 'FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL';

export const FETCH_ADMIN_LIKE_RECIPES_STATS_LOADING = 'FETCH_ADMIN_LIKE_RECIPES_STATS_LOADING';
export const FETCH_ADMIN_LIKE_RECIPES_STATS_SUCCESS = 'FETCH_ADMIN_LIKE_RECIPES_STATS_SUCCESS';
export const FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL    = 'FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL';

export const FETCH_ADMIN_VIEW_RECIPES_STATS_LOADING = 'FETCH_ADMIN_VIEW_RECIPES_STATS_LOADING';
export const FETCH_ADMIN_VIEW_RECIPES_STATS_SUCCESS = 'FETCH_ADMIN_VIEW_RECIPES_STATS_SUCCESS';
export const FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL    = 'FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL';

export const FETCH_ADMIN_BRANDS_STATS_LOADING  = 'FETCH_ADMIN_BRANDS_STATS_LOADING';
export const FETCH_ADMIN_BRANDS_STATS_SUCCESS  = 'FETCH_ADMIN_BRANDS_STATS_SUCCESS';
export const FETCH_ADMIN_BRANDS_STATS_FAIL     = 'FETCH_ADMIN_BRANDS_STATS_FAIL';

export const FETCH_ADMIN_BRAND_CATEGORY_STATS_LOADING  = 'FETCH_ADMIN_BRAND_CATEGORY_STATS_LOADING';
export const FETCH_ADMIN_BRAND_CATEGORY_STATS_SUCCESS  = 'FETCH_ADMIN_BRAND_CATEGORY_STATS_SUCCESS';
export const FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL     = 'FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL';

export const FETCH_ADMIN_BARS_STATS_LOADING  = 'FETCH_ADMIN_BARS_STATS_LOADING';
export const FETCH_ADMIN_BARS_STATS_SUCCESS  = 'FETCH_ADMIN_BARS_STATS_SUCCESS';
export const FETCH_ADMIN_BARS_STATS_FAIL     = 'FETCH_ADMIN_BARS_STATS_FAIL';

export const FETCH_ADMIN_BLOG_STATS_LOADING = 'FETCH_ADMIN_BLOG_STATS_LOADING';
export const FETCH_ADMIN_BLOG_STATS_SUCCESS = 'FETCH_ADMIN_BLOG_STATS_SUCCESS';
export const FETCH_ADMIN_BLOG_STATS_FAIL    = 'FETCH_ADMIN_BLOG_STATS_FAIL';

export const FETCH_ADMIN_BLOG_NEWS_STATS_LOADING = 'FETCH_ADMIN_BLOG_NEWS_STATS_LOADING';
export const FETCH_ADMIN_BLOG_NEWS_STATS_SUCCESS = 'FETCH_ADMIN_BLOG_NEWS_STATS_SUCCESS';
export const FETCH_ADMIN_BLOG_NEWS_STATS_FAIL    = 'FETCH_ADMIN_BLOG_NEWS_STATS_FAIL';

export const FETCH_ADMIN_USER_ADDITIONAL_LOADING  = 'FETCH_ADMIN_USER_ADDITIONAL_LOADING';
export const FETCH_ADMIN_USER_ADDITIONAL_SUCCESS  = 'FETCH_ADMIN_USER_ADDITIONAL_SUCCESS';
export const FETCH_ADMIN_USER_ADDITIONAL_FAIL     = 'FETCH_ADMIN_USER_ADDITIONAL_FAIL';

export const FETCH_ADMIN_CURATED_RECIPES_ADDL_LOADING  = 'FETCH_ADMIN_CURATED_RECIPES_ADDL_LOADING';
export const FETCH_ADMIN_CURATED_RECIPES_ADDL_SUCCESS  = 'FETCH_ADMIN_CURATED_RECIPES_ADDL_SUCCESS';
export const FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL     = 'FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL';

export const FETCH_ADMIN_CUSTOM_RECIPES_ADDL_LOADING = 'FETCH_ADMIN_CUSTOM_RECIPES_ADDL_LOADING';
export const FETCH_ADMIN_CUSTOM_RECIPES_ADDL_SUCCESS = 'FETCH_ADMIN_CUSTOM_RECIPES_ADDL_SUCCESS';
export const FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL    = 'FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL';

export const FETCH_ADMIN_MAKE_RECIPE_ADDL_LOADING = 'FETCH_ADMIN_MAKE_RECIPE_ADDL_LOADING';
export const FETCH_ADMIN_MAKE_RECIPE_ADDL_SUCCESS = 'FETCH_ADMIN_MAKE_RECIPE_ADDL_SUCCESS';
export const FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL    = 'FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL';

export const FETCH_LIKE_RECIPE_ADDITIONAL_REQUEST  = 'FETCH_LIKE_RECIPE_ADDITIONAL_REQUEST';
export const FETCH_LIKE_RECIPE_ADDITIONAL_SUCCESS  = 'FETCH_LIKE_RECIPE_ADDITIONAL_SUCCESS';
export const FETCH_LIKE_RECIPE_ADDITIONAL_FAIL     = 'FETCH_LIKE_RECIPE_ADDITIONAL_FAIL';

export const FETCH_VIEW_RECIPE_ADDITIONAL_REQUEST = 'FETCH_VIEW_RECIPE_ADDITIONAL_REQUEST';
export const FETCH_VIEW_RECIPE_ADDITIONAL_SUCCESS = 'FETCH_VIEW_RECIPE_ADDITIONAL_SUCCESS';
export const FETCH_VIEW_RECIPE_ADDITIONAL_FAIL    = 'FETCH_VIEW_RECIPE_ADDITIONAL_FAIL';

export const FETCH_ADMIN_BRAND_ADDITIONAL_LOADING = 'FETCH_ADMIN_BRAND_ADDITIONAL_LOADING';
export const FETCH_ADMIN_BRAND_ADDITIONAL_SUCCESS = 'FETCH_ADMIN_BRAND_ADDITIONAL_SUCCESS';
export const FETCH_ADMIN_BRAND_ADDITIONAL_FAIL    = 'FETCH_ADMIN_BRAND_ADDITIONAL_FAIL';

export const FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_LOADING = 'FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_LOADING';
export const FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_SUCCESS = 'FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_SUCCESS';
export const FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL    = 'FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL';

export const FETCH_ADMIN_BLOG_ADDITIONAL_LOADING = 'FETCH_ADMIN_BLOG_ADDITIONAL_LOADING';
export const FETCH_ADMIN_BLOG_ADDITIONAL_SUCCESS = 'FETCH_ADMIN_BLOG_ADDITIONAL_SUCCESS';
export const FETCH_ADMIN_BLOG_ADDITIONAL_FAIL    = 'FETCH_ADMIN_BLOG_ADDITIONAL_FAIL';

export const FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_LOADING = 'FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_LOADING';
export const FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_SUCCESS = 'FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_SUCCESS';
export const FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL = 'FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL';


// Ingredients analytics (ingredient-page-info)
export const FETCH_INGREDIENTS_PAGE_INFO_LOADING = 'FETCH_INGREDIENTS_PAGE_INFO_LOADING';
export const FETCH_INGREDIENTS_PAGE_INFO_SUCCESS = 'FETCH_INGREDIENTS_PAGE_INFO_SUCCESS';
export const FETCH_INGREDIENTS_PAGE_INFO_FAIL    = 'FETCH_INGREDIENTS_PAGE_INFO_FAIL';

// Recipe Ingredients Analytics
export const FETCH_RECIPE_INGREDIENTS_ANALYTICS_LOADING = 'FETCH_RECIPE_INGREDIENTS_ANALYTICS_LOADING';
export const FETCH_RECIPE_INGREDIENTS_ANALYTICS_SUCCESS = 'FETCH_RECIPE_INGREDIENTS_ANALYTICS_SUCCESS';
export const FETCH_RECIPE_INGREDIENTS_ANALYTICS_FAIL    = 'FETCH_RECIPE_INGREDIENTS_ANALYTICS_FAIL';


// User management (create/delete)

export const CREATE_USER_LOADING = "CREATE_USER_LOADING";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL    = "CREATE_USER_FAIL";

export const DELETE_USER_LOADING = "DELETE_USER_LOADING";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL    = "DELETE_USER_FAIL";

//Settings - Notify Users Credentials
export const NOTIFY_CREDENTIALS_LOADING = 'NOTIFY_CREDENTIALS_LOADING';
export const NOTIFY_CREDENTIALS_SUCCESS = 'NOTIFY_CREDENTIALS_SUCCESS';
export const NOTIFY_CREDENTIALS_FAIL    = 'NOTIFY_CREDENTIALS_FAIL';

// AI Chat Types
export const FETCH_AI_CARDS_LOADING = 'FETCH_AI_CARDS_LOADING';
export const FETCH_AI_CARDS_SUCCESS = 'FETCH_AI_CARDS_SUCCESS';
export const FETCH_AI_CARDS_FAIL    = 'FETCH_AI_CARDS_FAIL';

export const SEND_AI_MESSAGE_LOADING = 'SEND_AI_MESSAGE_LOADING';
export const SEND_AI_MESSAGE_SUCCESS = 'SEND_AI_MESSAGE_SUCCESS';
export const SEND_AI_MESSAGE_FAIL    = 'SEND_AI_MESSAGE_FAIL';

export const FETCH_AI_SESSIONS_LOADING = 'FETCH_AI_SESSIONS_LOADING';
export const FETCH_AI_SESSIONS_SUCCESS = 'FETCH_AI_SESSIONS_SUCCESS';
export const FETCH_AI_SESSIONS_FAIL    = 'FETCH_AI_SESSIONS_FAIL';

export const FETCH_AI_SESSION_HISTORY_LOADING = 'FETCH_AI_SESSION_HISTORY_LOADING';
export const FETCH_AI_SESSION_HISTORY_SUCCESS = 'FETCH_AI_SESSION_HISTORY_SUCCESS';
export const FETCH_AI_SESSION_HISTORY_FAIL    = 'FETCH_AI_SESSION_HISTORY_FAIL';
export const ADD_USER_MESSAGE = 'ADD_USER_MESSAGE';
export const AI_RECEIVE_MESSAGE = 'AI_RECEIVE_MESSAGE';
export const CLEAR_AI_HISTORY = 'CLEAR_AI_HISTORY';

export const CREATE_AI_SESSION_REQUEST  = 'CREATE_AI_SESSION_REQUEST';
export const CREATE_AI_SESSION_SUCCESS  = 'CREATE_AI_SESSION_SUCCESS';
export const CREATE_AI_SESSION_FAILURE  = 'CREATE_AI_SESSION_FAILURE';

export const FETCH_AI_ANALYTICS_HISTORY_LOADING = 'FETCH_AI_ANALYTICS_HISTORY_LOADING';
export const FETCH_AI_ANALYTICS_HISTORY_SUCCESS = 'FETCH_AI_ANALYTICS_HISTORY_SUCCESS';
export const FETCH_AI_ANALYTICS_HISTORY_FAIL    = 'FETCH_AI_ANALYTICS_HISTORY_FAIL';

// --- Roles
export const FETCH_ROLES_LOADING = 'FETCH_ROLES_LOADING';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAIL    = 'FETCH_ROLES_FAIL';

// --- Update user role
export const UPDATE_USER_ROLE_LOADING = 'UPDATE_USER_ROLE_LOADING';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_FAIL    = 'UPDATE_USER_ROLE_FAIL';

// Permissions (master list)
export const FETCH_PERMISSIONS_LOADING = 'FETCH_PERMISSIONS_LOADING';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAIL    = 'FETCH_PERMISSIONS_FAIL';

// Permissions by Role
export const FETCH_ROLE_PERMISSIONS_LOADING = 'FETCH_ROLE_PERMISSIONS_LOADING';
export const FETCH_ROLE_PERMISSIONS_SUCCESS = 'FETCH_ROLE_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_PERMISSIONS_FAIL    = 'FETCH_ROLE_PERMISSIONS_FAIL';

// Replace Role Permissions
export const REPLACE_ROLE_PERMISSIONS_LOADING = 'REPLACE_ROLE_PERMISSIONS_LOADING';
export const REPLACE_ROLE_PERMISSIONS_SUCCESS = 'REPLACE_ROLE_PERMISSIONS_SUCCESS';
export const REPLACE_ROLE_PERMISSIONS_FAIL    = 'REPLACE_ROLE_PERMISSIONS_FAIL';

// Roles: create
export const CREATE_ROLE_LOADING = 'CREATE_ROLE_LOADING';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL    = 'CREATE_ROLE_FAIL';

//Roles: delete
export const DELETE_ROLE_LOADING = 'DELETE_ROLE_LOADING';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAIL    = 'DELETE_ROLE_FAIL';

// Testing PostGres
export const FETCH_LATEST_PGRECIPES_LOADING = 'FETCH_LATEST_PGRECIPES_LOADING';
export const FETCH_LATEST_PGRECIPES_SUCCESS = 'FETCH_LATEST_PGRECIPES_SUCCESS';
export const FETCH_LATEST_PGRECIPES_FAIL = 'FETCH_LATEST_PGRECIPES_FAIL';

// Channel (UK/India) Orders — action types

export const FETCH_CHANNEL_ORDERS_LOADING = "FETCH_CHANNEL_ORDERS_LOADING";
export const FETCH_CHANNEL_ORDERS_SUCCESS = "FETCH_CHANNEL_ORDERS_SUCCESS";
export const FETCH_CHANNEL_ORDERS_FAIL    = "FETCH_CHANNEL_ORDERS_FAIL";

export const FETCH_CHANNEL_ORDER_DETAILS_LOADING = "FETCH_CHANNEL_ORDER_DETAILS_LOADING";
export const FETCH_CHANNEL_ORDER_DETAILS_SUCCESS = "FETCH_CHANNEL_ORDER_DETAILS_SUCCESS";
export const FETCH_CHANNEL_ORDER_DETAILS_FAIL    = "FETCH_CHANNEL_ORDER_DETAILS_FAIL";

export const FETCH_CHANNEL_ORDERS_COMPARISON_LOADING = "FETCH_CHANNEL_ORDERS_COMPARISON_LOADING";
export const FETCH_CHANNEL_ORDERS_COMPARISON_SUCCESS = "FETCH_CHANNEL_ORDERS_COMPARISON_SUCCESS";
export const FETCH_CHANNEL_ORDERS_COMPARISON_FAIL    = "FETCH_CHANNEL_ORDERS_COMPARISON_FAIL";

// UI state
export const SET_CHANNEL_ORDERS_PAGE_CURRENT  = "SET_CHANNEL_ORDERS_PAGE_CURRENT";
export const SET_CHANNEL_ORDERS_ITEMS_PER_PAGE= "SET_CHANNEL_ORDERS_ITEMS_PER_PAGE";
export const SET_CHANNEL_ORDERS_DATE_RANGE    = "SET_CHANNEL_ORDERS_DATE_RANGE";
export const SET_CHANNEL_ORDERS_CURRENCY      = "SET_CHANNEL_ORDERS_CURRENCY";

// Orders product sales (US channel, per-day & per-month analytics)
export const FETCH_ORDERS_PRODUCT_SALES_LOADING           = "FETCH_ORDERS_PRODUCT_SALES_LOADING";
export const FETCH_ORDERS_PRODUCT_SALES_SUCCESS           = "FETCH_ORDERS_PRODUCT_SALES_SUCCESS";
export const FETCH_ORDERS_PRODUCT_SALES_FAIL              = "FETCH_ORDERS_PRODUCT_SALES_FAIL";

export const FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_LOADING  = "FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_LOADING";
export const FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_SUCCESS  = "FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_SUCCESS";
export const FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL     = "FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL";

// Channel (UK/India) product sales
export const FETCH_CHANNEL_PRODUCT_SALES_LOADING  = "FETCH_CHANNEL_PRODUCT_SALES_LOADING";
export const FETCH_CHANNEL_PRODUCT_SALES_SUCCESS  = "FETCH_CHANNEL_PRODUCT_SALES_SUCCESS";
export const FETCH_CHANNEL_PRODUCT_SALES_FAIL     = "FETCH_CHANNEL_PRODUCT_SALES_FAIL";

export const FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_LOADING = "FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_LOADING";
export const FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_SUCCESS = "FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_SUCCESS";
export const FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL    = "FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL";

// Analytics Products - Options for UI filters
export const FETCH_ANALYTICS_PRODUCT_OPTIONS_LOADING = "FETCH_ANALYTICS_PRODUCT_OPTIONS_LOADING";
export const FETCH_ANALYTICS_PRODUCT_OPTIONS_SUCCESS = "FETCH_ANALYTICS_PRODUCT_OPTIONS_SUCCESS";
export const FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL    = "FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL";


// Orders product units (US channel, per-day & per-month analytics)
export const FETCH_ORDERS_PRODUCT_UNITS_LOADING           = "FETCH_ORDERS_PRODUCT_UNITS_LOADING";
export const FETCH_ORDERS_PRODUCT_UNITS_SUCCESS           = "FETCH_ORDERS_PRODUCT_UNITS_SUCCESS";
export const FETCH_ORDERS_PRODUCT_UNITS_FAIL              = "FETCH_ORDERS_PRODUCT_UNITS_FAIL";

export const FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_LOADING  = "FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_LOADING";
export const FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_SUCCESS  = "FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_SUCCESS";
export const FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL     = "FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL";

// Channel (UK/India) product units (per-day & per-month analytics)
export const FETCH_CHANNEL_PRODUCT_UNITS_LOADING          = "FETCH_CHANNEL_PRODUCT_UNITS_LOADING";
export const FETCH_CHANNEL_PRODUCT_UNITS_SUCCESS          = "FETCH_CHANNEL_PRODUCT_UNITS_SUCCESS";
export const FETCH_CHANNEL_PRODUCT_UNITS_FAIL             = "FETCH_CHANNEL_PRODUCT_UNITS_FAIL";

export const FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_LOADING = "FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_LOADING";
export const FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_SUCCESS = "FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_SUCCESS";
export const FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL    = "FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL";

// Orders units heatmap by state (US channel)
export const FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_LOADING = "FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_LOADING";
export const FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_SUCCESS = "FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_SUCCESS";
export const FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL    = "FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL";

// Orders product comparison (two custom date ranges, optional UPC filter)
export const FETCH_ORDERS_PRODUCT_COMPARISON_LOADING = "FETCH_ORDERS_PRODUCT_COMPARISON_LOADING";
export const FETCH_ORDERS_PRODUCT_COMPARISON_SUCCESS = "FETCH_ORDERS_PRODUCT_COMPARISON_SUCCESS";
export const FETCH_ORDERS_PRODUCT_COMPARISON_FAIL    = "FETCH_ORDERS_PRODUCT_COMPARISON_FAIL";

// ---------------------------------------------------------------------------
// SHAKERPRO channel (shakerpro.barsys.com launch site — live feed proxy)
// ---------------------------------------------------------------------------

// Orders table
export const FETCH_SHAKERPRO_ORDERS_LOADING = "FETCH_SHAKERPRO_ORDERS_LOADING";
export const FETCH_SHAKERPRO_ORDERS_SUCCESS = "FETCH_SHAKERPRO_ORDERS_SUCCESS";
export const FETCH_SHAKERPRO_ORDERS_FAIL    = "FETCH_SHAKERPRO_ORDERS_FAIL";

// ShopMy channel (creator-attributed orders)
export const FETCH_SHOPMY_ORDERS_LOADING = "FETCH_SHOPMY_ORDERS_LOADING";
export const FETCH_SHOPMY_ORDERS_SUCCESS = "FETCH_SHOPMY_ORDERS_SUCCESS";
export const FETCH_SHOPMY_ORDERS_FAIL    = "FETCH_SHOPMY_ORDERS_FAIL";

// Order details
export const FETCH_SHAKERPRO_ORDER_DETAILS_LOADING = "FETCH_SHAKERPRO_ORDER_DETAILS_LOADING";
export const FETCH_SHAKERPRO_ORDER_DETAILS_SUCCESS = "FETCH_SHAKERPRO_ORDER_DETAILS_SUCCESS";
export const FETCH_SHAKERPRO_ORDER_DETAILS_FAIL    = "FETCH_SHAKERPRO_ORDER_DETAILS_FAIL";

// Orders comparison
export const FETCH_SHAKERPRO_ORDERS_COMPARISON_LOADING = "FETCH_SHAKERPRO_ORDERS_COMPARISON_LOADING";
export const FETCH_SHAKERPRO_ORDERS_COMPARISON_SUCCESS = "FETCH_SHAKERPRO_ORDERS_COMPARISON_SUCCESS";
export const FETCH_SHAKERPRO_ORDERS_COMPARISON_FAIL    = "FETCH_SHAKERPRO_ORDERS_COMPARISON_FAIL";

// Product sales (daily + monthly)
export const FETCH_SHAKERPRO_PRODUCT_SALES_LOADING = "FETCH_SHAKERPRO_PRODUCT_SALES_LOADING";
export const FETCH_SHAKERPRO_PRODUCT_SALES_SUCCESS = "FETCH_SHAKERPRO_PRODUCT_SALES_SUCCESS";
export const FETCH_SHAKERPRO_PRODUCT_SALES_FAIL    = "FETCH_SHAKERPRO_PRODUCT_SALES_FAIL";
export const FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_LOADING = "FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_LOADING";
export const FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_SUCCESS = "FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_SUCCESS";
export const FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_FAIL    = "FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_FAIL";

// Product units (daily + monthly)
export const FETCH_SHAKERPRO_PRODUCT_UNITS_LOADING = "FETCH_SHAKERPRO_PRODUCT_UNITS_LOADING";
export const FETCH_SHAKERPRO_PRODUCT_UNITS_SUCCESS = "FETCH_SHAKERPRO_PRODUCT_UNITS_SUCCESS";
export const FETCH_SHAKERPRO_PRODUCT_UNITS_FAIL    = "FETCH_SHAKERPRO_PRODUCT_UNITS_FAIL";
export const FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_LOADING = "FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_LOADING";
export const FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_SUCCESS = "FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_SUCCESS";
export const FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_FAIL    = "FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_FAIL";

// Fulfillment write-back (mark shipped from the dashboard)
export const FULFILL_SHAKERPRO_ORDER_LOADING = "FULFILL_SHAKERPRO_ORDER_LOADING";
export const FULFILL_SHAKERPRO_ORDER_SUCCESS = "FULFILL_SHAKERPRO_ORDER_SUCCESS";
export const FULFILL_SHAKERPRO_ORDER_FAIL    = "FULFILL_SHAKERPRO_ORDER_FAIL";

// Customer journey (Braze-backed, on order details)
export const FETCH_CUSTOMER_JOURNEY_LOADING = "FETCH_CUSTOMER_JOURNEY_LOADING";
export const FETCH_CUSTOMER_JOURNEY_SUCCESS = "FETCH_CUSTOMER_JOURNEY_SUCCESS";
export const FETCH_CUSTOMER_JOURNEY_FAIL    = "FETCH_CUSTOMER_JOURNEY_FAIL";
